import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { seguridadDAModulo } from 'src/app/aplicaciones-modulos/seguridadDA/diccionarios/seguridadDAModule';
import { AplicacionUserFrontModel } from '../model/aplicacionUserFrontModel';

@Injectable({
  providedIn: 'root'
})
export class AplicacionUserService {

  diccionarioUrl: any;
  urlUniforme: string;
  
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlUniforme = this.utilServices.getNomina();
    //this.urlUniforme = "http://localhost:8080/nomina-api/v1/api/services/"
    this.diccionarioUrl = seguridadDAModulo.url.seguridad;
  }

  getAllEmpleado() {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.aplicacionUser + '/employe');
  } 

  getAllAplicacionUser() {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.aplicacionUser);
  } 

  findByNick(nick: string) {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.aplicacionUser+'/byNickName/'+nick);
  } 

  findByUserKosmos(idLogin:string){
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.aplicacionUser+'/find-kosmos-user/'+idLogin);
  }

  createAplicacionUser(item: AplicacionUserFrontModel){
    return this.commom.peticionPostConHeader(this.urlUniforme + this.diccionarioUrl.aplicacionUser, item);
  }

  updateAplicacionUser(item: AplicacionUserFrontModel){
    return this.commom.peticionPutConHeader(this.urlUniforme + this.diccionarioUrl.aplicacionUser, item);
  }

  deleteAplicacionUser(cedula: string, idApp: number){
    return this.commom.peticionDeleteConHeader(this.urlUniforme + this.diccionarioUrl.aplicacionUser + '/' + cedula + '/' + idApp);
  }

  
  getNickNamesByCedula(cedula: string){
    return this.commom.peticionGetConHeader(this.urlUniforme + 'syncDA/nickName/' + cedula);
  }

  getEmpleadoByCedula(cedula:string){
    return this.commom.peticionGetConHeader(this.urlUniforme + 'empleado/'+cedula);
  }

}
